import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "vue-color/style.css";
import { filemanager } from "./store/filemanager.module";
import { hydrateCampaignsFromIndexedDb } from "./store/campaigns.module";
import Dashboard from "./dashboard";
import axios from 'axios'
import VueAxios from 'vue-axios'
import { installAxiosErrorNotifications } from '@/helpers/axiosErrorNotifications';
import { startAppUpdateCheck } from '@/helpers/appUpdateCheck';

import * as Sentry from "@sentry/vue";


const appInstance = createApp(App);
appInstance.use(store);
installAxiosErrorNotifications(store, axios);
appInstance.use(router);
appInstance.use(Dashboard);
appInstance.use(VueAxios,axios);
if (process.env.APP_ENV === 'production') {

  Sentry.init({
    appInstance,
    dsn: "https://870368cd4a063cc52f0680512cd66ce7@o4511506085314560.ingest.de.sentry.io/4511506086821968",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}


hydrateCampaignsFromIndexedDb()
  .catch((err) => console.error("Failed to hydrate campaigns cache", err))
  .finally(() => {
    appInstance.mount("#app");
    startAppUpdateCheck();
    store.dispatch("auth/amILoggedIn").then(() => {
      store.registerModule('filemanager', filemanager);
    }).catch(() => {
      // Not logged in err
    });
  });

store.watch(
    function (state) {
        return state;
    },

    function (state) {
      let store = {
          version: state.version,
          darkMode: state.darkMode,
          sidebarType: state.sidebarType,
          layout: state.layout,
          //activeReporting: state.activeReporting,
          activeReportingDates: state.activeReportingDates,
          activeReportingTimezone: state.activeReportingTimezone,
          campaignGrouping: state.campaignGrouping
      };
  
      localStorage.setItem('store', JSON.stringify(store));
    },
    {
      deep: true //add this if u need to watch object properties change etc.
    }
);